import { render, staticRenderFns } from "./DateSpan.vue?vue&type=template&id=484f9edb&scoped=true"
import script from "./DateSpan.vue?vue&type=script&lang=js"
export * from "./DateSpan.vue?vue&type=script&lang=js"
import style0 from "./DateSpan.vue?vue&type=style&index=0&id=484f9edb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484f9edb",
  null
  
)

export default component.exports